// ** React Imports
import {useState, createContext, useEffect} from 'react'
/* ************************************************ */
import {IntlProvider} from 'react-intl'
import flatten from 'flat'
import _ from "lodash"
/* ************************************************ */
import {_changeAppLang, _setAppLang, _setGlobal, env} from '../Utils'
import {genLang} from '@src/assets/data/locales'
import {userLang} from '@modules/user'
import {logLang} from '@modules/log'
import {useRTL} from "../hooks/useRTL"

// ** Create Context
const Context = createContext()

const IntlProviderWrapper = ({children, additionalLangs}) => {

  const en = additionalLangs.en
  const ar = additionalLangs.ar
  const de = additionalLangs.de
  const fr = additionalLangs.fr

  delete additionalLangs.en
  delete additionalLangs.ar
  delete additionalLangs.de
  delete additionalLangs.fr

// ** Menu msg obj
  const menuMessages = {
    en: {...genLang.en, ...en},
    ar: {...genLang.ar, ...ar},
    de: {...genLang.de, ...de},
    fr: {...genLang.fr, ...fr},
    ...additionalLangs
  }
  // ** States
  const defaultLang = env('REACT_APP_DEFAULT_LANG', 'en')
  const localStorageLang = localStorage.getItem('APP_LANG')
  const lang = localStorageLang ? localStorageLang : defaultLang
  const [locale, setLocale] = useState(lang)
  const [messages, setMessages] = useState(flatten(menuMessages[lang]))
  _setGlobal('messages', messages)
  const [isRtl, setIsRtl] = useRTL()
  _setAppLang(lang)

  useEffect(() => {
    if (locale === 'ar') {
      setIsRtl(true)
    } else {
      setIsRtl(false)
    }
    return () => {
    }
  }, [])

  // ** Switches Language
  const switchLanguage = lang => {
    _changeAppLang(lang)
  }

  // ** Switches Language
  const plainText = key => {
    return _.get(menuMessages, `${locale}.${key}`) ?? key
  }

  return (
    <Context.Provider value={{locale, switchLanguage, plainText}}>
      <IntlProvider key={locale} locale={locale} messages={messages} defaultLocale={defaultLang}>
        {children}
      </IntlProvider>
    </Context.Provider>
  )
}

export {IntlProviderWrapper, Context as IntlContext}
